var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,5.4v69.1h69.1V5.4H5.4z M71.6,71.6H8.4V8.4h63.1V71.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9.7,
    width: 9.7,
    x: 16.6,
    y: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 29.8,
    x: 33.6,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 46.8,
    x: 16.6,
    y: 34.1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 46.8,
    x: 16.6,
    y: 44.7
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8.2,
    width: 46.7,
    x: 16.6,
    y: 55.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.cfe53bc22115faf34a40f2b7313c6b17.svg";
export { ForwardRef as ReactComponent };